import React, { useEffect, useState } from 'react'
import {
  Form,
  Input,
  Switch,
  Button,
  Card,
  Modal,
  message,
  Checkbox,
  Upload,
  Spin,
} from 'antd'
import { InboxOutlined, UploadOutlined } from '@ant-design/icons'
import './Common.module.css'
import styles from './Common.module.css'
import {
  edtZiyuanRequest,
  getAliOssTokenRequest,
  getXuekeListRequest,
  uploadDetailFileRequest,
} from '../api'
import OSS from 'ali-oss'
import { getSixMathRandom } from '../../../../util/handMath'
import {
  ALI_OSS_PATH,
  API_URL,
  HTTP_URL,
  PHP_API_URL,
} from '../../../../util/constants'
import Dragger from 'antd/es/upload/Dragger'
import { getGradeArrayByCodeStr } from '../../../../util/handleObject'
const { TextArea } = Input

const CheckboxGroup = Checkbox.Group

let client
let clientExpTime
const AddAccountForm = (props) => {
  const [form] = Form.useForm()
  const [accountStatus, setAccountStatus] = useState(true)
  const [zipFileList, setZipFileList] = useState([])
  const [bannerFileList, setBannerFileList] = useState([])
  const [detailLink, setDetailLink] = useState('')
  const [progress, setProgress] = useState(0)

  const [gradeList, setGradeList] = useState([])
  const [subjectList, setSubjectList] = useState([])
  const [gradeCheckedList, setGradeCheckedList] = useState([])
  const [subjectCheckedList, setSubjectCheckedList] = useState([])
  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    if (props.openStatus) {
      getXuekeList()
      getAliOssToken()
      form.setFieldsValue({
        resourceName: props.editInfo.title,
        des: props.editInfo.jianjie,
        jifen: props.editInfo.jifen,
        grades: props.editInfo.shiyong_nianji.split(','),
        subjects: props.editInfo.shiyong_xueke.split(','),
        status: props.editInfo.status === '1' ? true : false,
      })
      setDetailLink(props.editInfo.xiangqing_url)
      setBannerFileList([
        {
          url: props.editInfo.fengmian_url,
          uid: '123',
          status: true,
          name: decodeURIComponent(
            props.editInfo.fengmian_url.split('file/banner/')[1],
          ),
        },
      ])
      setZipFileList([
        {
          url: props.editInfo.ziyuan_url,
          uid: '1231',
          status: true,
          name: decodeURIComponent(
            props.editInfo.ziyuan_url.split('file/file/')[1],
          ),
          size:props.editInfo.size,
        },
      ])
      setGradeCheckedList(
        props.editInfo.shiyong_nianji.split(','),
      )
      setSubjectCheckedList(
        props.editInfo.shiyong_xueke.split(','),
      )
    } else {
      form.resetFields()
      setDetailLink('')
      setBannerFileList([])
      setZipFileList([])
    }
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  }, [props.openStatus]) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  function getXuekeList() {
    getXuekeListRequest('', (data) => {
      if (data.ret == 1) {
        let tempGradeList = data.data.nianji_list.map((item) => ({
          label: item.name,
          value: item.code,
        }))
        setGradeList(tempGradeList)

        let tempSubjectList = data.data.xueke_list.map((item) => ({
          label: item.name,
          value: item.code,
        }))
        setSubjectList(tempSubjectList)
      } else {
        message.error(data.msg)
      }
    })
  }

  const onFinish = (values) => {
    if (zipFileList.length === 0) {
      message.error('请上传压缩包')
      return
    }
    if (bannerFileList.length === 0) {
      message.error('请上传封面图')
      return
    }
    // 这里可以添加API调用或其他提交逻辑
    form.validateFields().then((values) => {
      console.log('表单数据:', values)
      var ziyuan_name = values.resourceName
      var des = values.des
      var jifen = values.jifen

      var ziyuan_url = zipFileList[0].url
      var fengmian_link = bannerFileList[0].url
      var grade_code_str = gradeCheckedList.join(',')
      var subject_code_str = subjectCheckedList.join(',')
      var size = Number((zipFileList[0].size / 1024 / 1024).toFixed(2))
      size = size<0.01?0.01:size
      var status = values.status === true ? '1' : '0'
      
      // 调用 API
      edtZiyuanRequest(
        status,
        props.editInfo.code,
        ziyuan_name,
        des,
        ziyuan_url,
        jifen,
        fengmian_link,
        grade_code_str,
        subject_code_str,
        detailLink,
        size,
        (data) => {
          console.log(data)
          if (data.ret === '1') {
            message.success('编辑成功', 1)
            props.updateData()
            props.closeCommonModal()
          } else {
            message.error(data.msg, 1)
          }
        },
      )
    })
  }

  const closeCommon = () => {
    props.closeCommonModal()
  }
  const onChangeGrade = (list) => {
    console.log('onChangeGrade', list)
    setGradeCheckedList(list)
  }
  const onChangeSubject = (list) => {
    console.log('onChangeSubject', list)
    setSubjectCheckedList(list)
  }
  function getAliOssToken() {
    let nowDate = new Date().getTime()
    if (!client || nowDate - clientExpTime > 1200000) {
      clientExpTime = new Date().getTime()
      getAliOssTokenRequest((data) => {
        if ('Credentials' in data) {
          client = new OSS({
            // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
            region: 'oss-cn-qingdao',
            // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
            accessKeyId: data.Credentials.AccessKeyId,
            accessKeySecret: data.Credentials.AccessKeySecret,
            // 从STS服务获取的安全令牌（SecurityToken）。
            stsToken: data.Credentials.SecurityToken,
            refreshSTSToken: async () => {
              // 向您搭建的STS服务获取临时访问凭证。
              getAliOssTokenRequest((data) => {
                return {
                  accessKeyId: data.Credentials.AccessKeyId,
                  accessKeySecret: data.Credentials.AccessKeySecret,
                  stsToken: data.Credentials.SecurityToken,
                }
              })
            },
            // 刷新临时访问凭证的时间间隔，单位为毫秒。
            refreshSTSTokenInterval: 3000000,
            // 填写Bucket名称。
            bucket: 'tgnp',
          })
        }
      })
    }
  }

  function handleChange(info, type) {
    getAliOssToken()
    let tempList = info.fileList.map((item, index) => {
      let tempDic = {
        url: item.url,
        uid: item.uid,
        status: item.status,
        name: item.name,
        size: item.size,
      }
      return tempDic
    })
    if (tempList.length > 1) {
      tempList = [tempList[tempList.length - 1]]
    }
    if (type === 'banner') {
      setBannerFileList(tempList)
    } else if (type === 'zip') {
      if (tempList.length>0) {
       form.setFieldsValue({
          resourceName: tempList[0].name,
        }) 
      } else {
        form.setFieldsValue({
          resourceName: "",
        })
      }
      setZipFileList(tempList)
    }
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList)
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} 上传成功`)
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} 上传失败`)
    }
  }
  const customRequest = async (options, type) => {
    const { onSuccess, onError, file } = options

    try {
      // 这一部分是上传到服务器的网页
      if (type === 'detailLink') {
        uploadDetailFileRequest(file, (data) => {
          console.log(file)
          if (data.ret === '1') {
            setDetailLink(HTTP_URL + data.data.file_name)
            message.success('上传成功', 1)
            file.url = HTTP_URL + data.data.file_name
            onSuccess(file)
          } else {
            message.error(data.msg, 1)
            setDetailLink('')
            onError(data.msg)
          }
        })
      } else {
        // 这一部分是上传到阿里云OSS的文件
        let pathName = ''
        let timestamp = new Date().getTime()
        let random = getSixMathRandom()
        if (type === 'banner') {
          pathName =
            ALI_OSS_PATH + 'file/banner/' + timestamp + random + file.name
        } else if (type === 'zip') {
          pathName =
            ALI_OSS_PATH + 'file/file/' + timestamp + random + file.name
        }
        const options = {
          // 获取分片上传进度、断点和返回值。
          progress: (p, cpt, res) => {
            console.log(p);
            setProgress(p)
          },
          // 设置并发上传的分片数量。
          parallel: 4,
          // 设置分片大小。默认值为1 MB，最小值为100 KB，最大值为5 GB。最后一个分片的大小允许小于100 KB。
          partSize: 1024 * 1024,
          // headers,
          // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
          // meta: { year: 2020, people: "test" },
          mime: "text/plain",
        };
        const result = await client.multipartUpload(pathName, file,{
          ...options
        })
        file.url = result.res.requestUrls[0].split('?')[0]
        onSuccess(file)
      }

      // changeImgMethod(file.url)
    } catch (e) {
      console.log(e)
      message.error(`教学材料文件上传失败`)
      onError(e)
    }
  }
  const zipProps1 = {
    name: 'file',
    accept: '.zip,.rar',
    multiple: false,
    // previewFile:true,
    customRequest: (options) => customRequest(options, 'zip'),
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files)
    },
    onChange: (info) => handleChange(info, 'zip'),
    beforeUpload(file) {
      const fileSize = file.size / 1024 / 1024 / 1024 < 1
      if (!fileSize) {
        message.error('教学材料文件必须小于1GB!')
        return false
      }
      // setExcelFile(file)
      // 通过FileReader对象读取文件
      return true
    },
    fileList: zipFileList,
  }

  const props2 = {
    name: 'file',
    accept: '.jpg,.jpeg,.png',
    multiple: false,
    // previewFile:true,
    customRequest: (options) => customRequest(options, 'banner'),
    onDrop(e) {
      console.log('ssDropped files', e.dataTransfer.files)
    },
    onChange: (info) => handleChange(info, 'banner'),
    beforeUpload(file) {
      const fileSize = file.size / 1024 / 1024 < 5
      if (!fileSize) {
        message.error('图片文件必须小于5MB!')
        return false
      }
      // setExcelFile(file)
      // 通过FileReader对象读取文件
      return true
    },
    fileList: bannerFileList,
  }

  return (
    <Modal
      maskClosable={false}
      // visible={true}
      open={props.openStatus}
      onCancel={closeCommon}
      footer={null} // 设置 footer 为 null 移除默认按钮
      width="80%"
      // className="add-account-container"
    >
      {progress>0&&progress<1?
      <Spin
        size="large"
        percent={progress*100}
        fullscreen={true}
        />:null}
      <Card className={styles['form-card']} span={20}>
        <div className={styles['form-title']}>编辑教学材料文件</div>
        <div className={styles['form-desc']}>
          请上传教学材料文件，文件大小不能超过1GB，支持zip、rar格式。
        </div>
        <Dragger {...zipProps1} className={styles.topContainer}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">拖拽压缩包到此处或点击上传</p>
          <p className="ant-upload-hint">
            支持格式：zip，rar | 最大文件大小1GB
          </p>
        </Dragger>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          className="account-form"
          width={'80%'}
          style={{ marginTop: 30 }}
        >
          <Form.Item
            label="资源名称"
            name="resourceName"
            rules={[{ required: true, message: '请输入资源名称' }]}
          >
            <Input placeholder="请输入资源名称" size="large" />
          </Form.Item>

          <Form.Item
            label="适用年级（可多选）"
            name="grades"
            rules={[{ required: true, message: '请输入适用年级' }]}
          >
            <CheckboxGroup
              options={gradeList}
              value={[gradeCheckedList]}
              onChange={onChangeGrade}
            />
          </Form.Item>
          <Form.Item
            label="适用学科（可多选）"
            name="subjects"
            rules={[{ required: true, message: '请输入适用学科' }]}
          >
            <CheckboxGroup
              options={subjectList}
              value={subjectCheckedList}
              onChange={onChangeSubject}
            />
          </Form.Item>

          <Form.Item
            label="内容介绍"
            name="des"
            rules={[{ required: true, message: '请输入内容介绍' }]}
          >
            <Input.TextArea placeholder="请输入内容介绍" size="large" />
          </Form.Item>
          <Form.Item
            label="资源状态"
            name="status"
            rules={[{ required: false, message: '请选择资源状态' }]}
          >
            <Switch />
          </Form.Item>
          <Form.Item
            label="详情链接"
            name="detailLink"
            rules={[{ required: false, message: '请输入详情链接' }]}
          >
            <Upload
              listType="picture"
              fileList={[]}
              customRequest={(options) => customRequest(options, 'detailLink')}
              onChange={(info) => handleChange(info, 'detailLink')}
              accept=".html"
            >
              {/* {detailLink == '' ? ( */}
              <Button type="primary" icon={<UploadOutlined />}>
                {detailLink == '' ? '上传详情链接文件' : detailLink}
              </Button>
              {/* // ) 
              // : (
              //   <p className={styles.uploadButton}>{detailLink}</p>
              // )
              } */}
            </Upload>
          </Form.Item>
          <Form.Item
            label="下载所需积分"
            name="jifen"
            rules={[{ required: true, message: '请输入下载所需积分' }]}
          >
            <Input
              type="number"
              placeholder="请输入下载所需积分"
              size="large"
            />
          </Form.Item>
          <Form.Item>
            <Dragger {...props2} className={styles.topContainer}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">拖拽图片到此处或点击上传</p>
              <p className="ant-upload-hint">
                支持格式：jpg,jpeg,png | 最大文件大小5MB
              </p>
            </Dragger>
          </Form.Item>
          <Form.Item>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 20,
              }}
            >
              <Button type="primary" htmlType="submit">
                保存
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Card>
    </Modal>
  )
}

export default AddAccountForm
